
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'

import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateTaskDate } from '../../../Services/ProgrammationManagerService'
import { updateTaskDateAction } from '../../../Redux/Actions/ProgrammationManagerActions'
import { useProject } from '../../../Hooks/UseProject'
import { useProjection } from '@/Hooks/ProjectionProvider'
import { useDatePicker } from '@/Hooks/UseDatePicker'
import { maxDate } from '@/Helpers/DateFunctions'
import { getExpectedEndDate } from '../../../Helpers/ProgrammationHelper'

import InputText from '../components/InputText'

interface Props {
  label: string
  fieldName: string
  disabled?: boolean
}

const TaskDate = ({ label, fieldName, disabled }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, patchItemOpened } = useProgrammation()
  const { project } = useProject()
  const { projectedEndDate, extendedNonWorkingDays } = useProjection()

  const { setEditingItem } = useProgrammation()

  const { showDatePicker } = useDatePicker()

  const [ date, setDate ] = useState('')

  const handleChangeDate = async (date: string) => {

    setDate(date)

    setEditingItem(true)

    const [ error, data ] = await updateTaskDate(itemOpened?._id, fieldName, date)

    setEditingItem(false)

    if (error) {
      return false;
    }

    patchItemOpened({
      [fieldName]: data.task[fieldName],
      executeDays: data.task.executeDays,
      startedAt: data.task.startedAt,
      endedAt: data.task.endedAt,
    })

    await dispatch(updateTaskDateAction(data.task, data.parentTask))
  }

  const handleShowDatePicker = () => {

    showDatePicker({
      date,
      projectStartDate: project.startsAt,
      projectEndDate: maxDate(project.endsAt, projectedEndDate) || project.endsAt,
      nonWorkingDays: extendedNonWorkingDays,
      onChange: handleChangeDate
    })
  }

  useEffect(() => {

    const getEstimatedEndDate = () => {

      const endDate = getExpectedEndDate(itemOpened.startedAt, itemOpened.executeDays, project.nonWorkingDays, true)
      setDate(moment(endDate).format('YYYY-MM-DD'))
    }

    const getDate = (date: string) => {

      const dateMoment = moment(date)

      setDate(dateMoment.format('YYYY-MM-DD'))
    }

    if (fieldName === 'endedAt' && !itemOpened.endedAt) {

      getEstimatedEndDate()
    } else {

      getDate(itemOpened[fieldName])
    }
  }, [itemOpened, fieldName])

  return (
    <Form.Group>
      <Form.Label>
        {t(label)}
      </Form.Label>
      <div className='mb-2'>
        <InputText
          value={date ? moment(date).format('DD/MM/YYYY') : ''}
          placeholder="dd/mm/yyyy"
          onClick={() => handleShowDatePicker()}
          asButton
          disabled={disabled}
        />
      </div>
    </Form.Group>
  )
}

export default TaskDate
